import React,{ Component } from 'react';
import {Row, Col, Button, ControlLabel, Checkbox} from 'react-bootstrap';
import FieldGroup from '../../../../components/FieldGroup';
import SelectWrap from "../../../../components/SelectWrap";
import countriesObj from "../../../../data/countries";
import { handleFieldChange } from "../../../../Utils";
import moment from "moment";

class Filters extends Component {
    constructor(props) {
        super(props);

        this.state = {
            dateFrom: '',
            dateTo: '',
            compareDateFrom: '',
            compareDateTo: '',
            country: '',
            source: '',
            partner: '',
            groupBy: {},
            realtime: false,
        };

        this.handleFieldChange = handleFieldChange.bind(this);
        this.handleGroupByChange = this.handleGroupByChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
    }

    handleFormSubmit(e) {
        e.preventDefault();

        const filters = {...this.state};
              filters.groupBy = Object.keys(filters.groupBy);

        if (filters.compareDateFrom && filters.compareDateTo) filters.compare = 1;

        if (filters.partner) {
            filters.partner = filters.partner.map(partner => this.props.partners[partner.trim()])
        }

        this.props.onSubmit(filters, { realtime: this.state.realtime });
    }

    handleGroupByChange({ target }) {
        const groupBy = { ...this.state.groupBy };
        const { name, checked } = target;

        if(checked) groupBy[name] = 1;
        else delete groupBy[name];

        this.setState({ groupBy });
    }

    render() {
        return (
            <form onSubmit={this.handleFormSubmit}>
                <Row>
                    <Col lg={12}>
                        <ControlLabel>Group By:</ControlLabel>
                        <Checkbox onChange={this.handleGroupByChange} name="day">Day</Checkbox>
                        <Checkbox onChange={this.handleGroupByChange} name="source">Source</Checkbox>
                        <Checkbox onChange={this.handleGroupByChange} name="onw">ONW</Checkbox>
                        <Checkbox onChange={this.handleGroupByChange} name="country">Country</Checkbox>
                        <Checkbox onChange={(event) => this.setState({ realtime: event.target.checked })} name="realtime">Realtime</Checkbox>
                    </Col>

                    <Col lg={3}>
                        <FieldGroup
                            type="date"
                            name="dateFrom"
                            label="Date From:"
                            max={moment().utc().format('YYYY-MM-DD')}
                            onChange={this.handleFieldChange}
                            value={this.state.dateFrom}
                        />
                    </Col>

                    <Col lg={3}>
                        <FieldGroup
                            type="date"
                            name="dateTo"
                            label="Date To:"
                            max={moment().utc().format('YYYY-MM-DD')}
                            onChange={this.handleFieldChange}
                            value={this.state.dateTo}
                        />
                    </Col>

                    <Col lg={3}>
                        <FieldGroup
                            type="date"
                            name="compareDateFrom"
                            label="Compare Date From:"
                            onChange={this.handleFieldChange}
                            value={this.state.compareDateFrom}
                        />
                    </Col>

                    <Col lg={3}>
                        <FieldGroup
                            type="date"
                            name="compareDateTo"
                            label="Compare Date To:"
                            onChange={this.handleFieldChange}
                            value={this.state.compareDateTo}
                        />
                    </Col>

                    <Col lg={6}>
                        <SelectWrap
                            values={countriesObj}
                            label="Countries:"
                            name="country"
                            onChange={this.handleFieldChange}
                            value={this.state.country}
                            multi
                        />
                    </Col>

                    <Col lg={6}>
                        <SelectWrap
                            values={this.props.sources}
                            label="Sources:"
                            name="source"
                            onChange={this.handleFieldChange}
                            value={this.state.source}
                            multi
                        />
                    </Col>
                </Row>

                <Row>
                    <Col lg={6}>
                        <SelectWrap
                            values={Object.keys(this.props.partners)}
                            label="Partners:"
                            name="partner"
                            onChange={this.handleFieldChange}
                            value={this.state.partner}
                            multi
                        />
                    </Col>
                </Row>

                <Button type="submit" bsStyle="info" className="m-b-15" >Apply</Button>
            </form>
        );
    }
}

export default Filters;



// WEBPACK FOOTER //
// ./src/scenes/BidderV2/components/Form/index.js